export default __webpack_public_path__ + "static/media/profile.2672bc98.jpg";